import get from 'lodash/get';

function onSuccess(actionContext, callContext) {
	const {
		response: { data },
	} = callContext;

	actionContext.dispatch('SET_SAVED_QUERIES', data);
}

function onFailed(actionContext, callContext) {
	const { error } = callContext;

	actionContext.dispatch('SET_SAVED_QUERIES', error);
}

export default config => ({
	serviceName: 'retrieveFilters',
	authenticate: true,
	config: {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		url: get(config, 'endpoints.prompt.filters.retrieve'),
	},
	onSuccess,
	onFailed,
	onError: onFailed,
	onTimeout: onFailed,
	onFatal: onFailed,
});
